// The information contained in this document are the sole property of LivingPackets. Any disclosure to any third party and any reproduction, in part or whole without the written permission of LivingPackets is prohibited
// Confidential - Copyright LivingPackets: All rights reserved

import { useQuery } from '@tanstack/react-query';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { QueryConfig } from '@/lib/react-query';

const getPartnerActivity = async ({
  partnerIds,
  makeRequest,
}: {
  partnerIds?: string[];
  makeRequest: any;
}): Promise<Record<string, boolean> | boolean> => {
  const { data, error } = await makeRequest({
    path: `/partners/activity`,
    method: 'POST',
    body: { partner_ids: partnerIds },
  });

  if (error) {
    throw new Error(error);
  }

  // If only one partner ID is provided, return a boolean indicating activity
  if (partnerIds && partnerIds.length === 1) {
    return data.partners_activity[0]?.activity;
  }

  return data.partners_activity.reduce(
    (acc: any, activity: { partner_id: string; activity: boolean }) => ({
      ...acc,
      [activity.partner_id]: {
        is_active: activity.activity,
      },
    }),
    {}
  );
};

type QueryFnType = typeof getPartnerActivity;

type UsePartnerActivityOptions = {
  config?: QueryConfig<QueryFnType>;
  partnerIds: string[];
};

export const useGetPartnersActivity = ({
  config,
  partnerIds,
}: UsePartnerActivityOptions) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');

  return useQuery({
    ...config,
    queryKey: ['partners', partnerIds, 'activity'],
    queryFn: () => getPartnerActivity({ partnerIds, makeRequest }),
  });
};
